(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lagos-image-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lagos-image-init')) {
  const mountLagosImage = (root) => {
    if (root.dataset.lagosMounted === 'true') return;
    root.dataset.lagosMounted = 'true';
    const productForm = root.querySelector('.lagos-image__form');
    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = productForm.querySelector('[data-lagos-image-submit]');
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      const errorNode = root.querySelector('[data-lagos-image-error]');
      const cartLink = root.querySelector('[data-lagos-image-cart]');
      errorNode.hidden = true;
      cartLink.hidden = true;
      let knownFailure = false;
      try {
        const data = new FormData(productForm);
        const response = await fetch(`${root.dataset.cartAdd}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(data.get('id')),quantity:1}]})});
        const result = await response.json();
        if (!response.ok) { knownFailure = true; throw new Error(result.description || root.dataset.cartError); }
        root.querySelector('[data-lagos-image-checkout]').submit();
      } catch (error) {
        errorNode.textContent = knownFailure ? error.message : root.dataset.cartError;
        errorNode.hidden = false;
        cartLink.hidden = false;
        if (knownFailure) submit.disabled = false;
      } finally { submit.removeAttribute('aria-busy'); }
    });
    const checkout = root.querySelector('.lagos-image__checkout');
    const sticky = root.querySelector('[data-lagos-image-sticky]');
    if (checkout && sticky) new IntersectionObserver((entries) => { sticky.hidden = entries.some((entry) => entry.isIntersecting); },{threshold:0.2}).observe(checkout);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('a[href^="#LagosImageCheckout-"]').forEach((anchor) => { anchor.addEventListener('click', (event) => { if (!checkout) return; event.preventDefault(); checkout.scrollIntoView({behavior:reducedMotion?'auto':'smooth',block:'start'}); }); });
  };
  document.querySelectorAll('[data-lagos-image]').forEach(mountLagosImage);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-lagos-image]').forEach(mountLagosImage); });
  customElements.define('lagos-image-init', class extends HTMLElement {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lagos-story-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lagos-story-init')) {
  const mountLagosStory = (root) => {
    if (root.dataset.lagosMounted === 'true') return;
    root.dataset.lagosMounted = 'true';
    const variantSelect = root.querySelector('[data-lagos-variant]');
    const variantsNode = root.querySelector('[data-lagos-variants]');
    const variants = JSON.parse(variantsNode?.textContent || '[]') || [];
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'es-EC', {style:'currency',currency:root.dataset.currency || 'USD'});
    const productForm = root.querySelector('.lagos-story__form');
    const addonWrap = productForm?.querySelector('[data-lagos-addon-wrap]');
    if (addonWrap) addonWrap.hidden = false;
    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = productForm.querySelector('[data-lagos-submit]');
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      const errorNode = root.querySelector('[data-lagos-error]');
      const cartLink = root.querySelector('[data-lagos-cart-link]');
      errorNode.hidden = true;
      cartLink.hidden = true;
      const data = new FormData(productForm);
      const items = [{id:Number(data.get('id')),quantity:1}];
      const extra = productForm.querySelector('[data-lagos-addon]');
      if (extra?.checked) items.push({id:Number(extra.value),quantity:1});
      let knownFailure = false;
      try {
        const response = await fetch(`${root.dataset.cartAdd}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) { knownFailure = true; throw new Error(result.description || root.dataset.cartError); }
        root.querySelector('[data-lagos-checkout]').submit();
      } catch (error) {
        errorNode.textContent = knownFailure ? error.message : root.dataset.cartError;
        errorNode.hidden = false;
        cartLink.hidden = false;
        if (knownFailure) submit.disabled = false;
      } finally { submit.removeAttribute('aria-busy'); }
    });
    variantSelect?.addEventListener('change', () => {
      const variant = variants.find((entry) => String(entry.id) === variantSelect.value);
      if (!variant) return;
      root.querySelectorAll('[data-lagos-price]').forEach((node) => { node.textContent = formatter.format(variant.price / 100); });
      root.querySelectorAll('[data-lagos-compare]').forEach((node) => { node.hidden = !(variant.compare_at_price > variant.price); node.textContent = formatter.format((variant.compare_at_price || 0) / 100); });
      const submit = root.querySelector('[data-lagos-submit]');
      if (submit) submit.disabled = !variant.available;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-lagos-demo]').forEach((demo) => {
      const video = demo.querySelector('video');
      if (!video) return;
      video.playbackRate = Number(demo.dataset.speed) || 1;
      if (reducedMotion) { video.pause(); video.autoplay = false; }
      const control = demo.parentElement.querySelector('[data-lagos-motion]');
      const pauseText = control?.textContent;
      control?.addEventListener('click', () => {
        if (video.paused) { video.play().catch(() => {}); control.setAttribute('aria-pressed', 'false'); }
        else { video.pause(); control.setAttribute('aria-pressed', 'true'); }
        if (pauseText) control.textContent = pauseText;
      });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) video.pause();
          else if (!reducedMotion && control?.getAttribute('aria-pressed') !== 'true') video.play().catch(() => {});
        });
      },{threshold:0.2});
      observer.observe(video);
    });
    root.querySelectorAll('[data-lagos-gif]').forEach((demo) => {
      const picture = demo.querySelector('img');
      const control = demo.parentElement.querySelector('[data-lagos-gif-motion]');
      if (!picture || !control) return;
      const poster = picture.getAttribute('src');
      let visible = false;
      let wantsMotion = !reducedMotion;
      const refresh = () => {
        const source = visible && wantsMotion ? demo.dataset.gifUrl : poster;
        if (picture.getAttribute('src') !== source) picture.setAttribute('src', source);
        control.setAttribute('aria-pressed', String(!wantsMotion));
      };
      control.hidden = false;
      control.addEventListener('click', () => { wantsMotion = !wantsMotion; refresh(); });
      new IntersectionObserver((entries) => { visible = entries.some((entry) => entry.isIntersecting); refresh(); }, {threshold:0.15}).observe(demo);
      refresh();
    });
    const checkout = root.querySelector('.lagos-story__order');
    const sticky = root.querySelector('[data-lagos-sticky]');
    if (checkout && sticky) {
      new IntersectionObserver((entries) => { sticky.hidden = entries.some((entry) => entry.isIntersecting); },{threshold:0.2}).observe(checkout);
    }
    root.querySelectorAll('a[href^="#LagosCheckout-"]').forEach((anchor) => { anchor.addEventListener('click', (event) => { const destination = root.querySelector('.lagos-story__order'); if (!destination) return; event.preventDefault(); destination.scrollIntoView({behavior:reducedMotion?'auto':'smooth',block:'start'}); }); });
  };
  document.querySelectorAll('[data-lagos-story]').forEach(mountLagosStory);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-lagos-story]').forEach(mountLagosStory); });
  customElements.define('lagos-story-init', class extends HTMLElement {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
